import React from "react"

import { Col, Row } from "react-bootstrap"

const ConfirmModal = props => {
  return (
    <>
      <h1>Confirm</h1>
      <p className="mb-4">
        {props?.text
          ? props?.text
          : " Are you sure want to delete ? You cannot undo after deleting."}
      </p>
      <Row>
        <Col>
          <button
            type="submit"
            className="btn w-100 btn-custom rounded btn-danger mb-2"
            value="  Save and continue"
            onClick={() => {
              props.onOkClick(0, props.id)
            }}
          >
            Ok
          </button>
        </Col>
      </Row>

      <Row>
        <Col>
          <button
            type="submit"
            className="btn w-100 btn-custom rounded primary"
            value="  Save and continue"
            onClick={() => props.setShow(0)}
          >
            Cancel
          </button>
        </Col>
      </Row>
    </>
  )
}

export default ConfirmModal
